export default __webpack_public_path__ + "static/media/default.bada718dbd43c14101e2315ca577d283.png";